import { Plan } from '../redux/types/planTypes'
import BaseRequest from './index'

class PlanService extends BaseRequest {
  constructor() {
    super()
    this.bindMethods()
  }

  bindMethods() {
    this.createPlan = this.createPlan.bind(this)
    this.validatePlanName = this.validatePlanName.bind(this)
    this.getUserPlans = this.getUserPlans.bind(this)
    this.getPlanById = this.getPlanById.bind(this)
    this.fundPlan = this.fundPlan.bind(this)
    this.updatePlan = this.updatePlan.bind(this)
    this.deletePlan = this.deletePlan.bind(this)
  }

  async validatePlanName<T>(data: any): Promise<T> {
    return await this.api.post('/user/plan/check', data)
  }

  async createPlan<T>(data: any): Promise<T> {
    return await this.api.post('/user/plan/create', data)
  }

  async getUserPlans<T>(): Promise<T> {
    return await this.api.get('/user/plan')
  }

  async getPlanById<T>(id: string): Promise<T> {
    return await this.api.get(`/user/plan/${id}/view`)
  }

  async fundPlan(data: any) {
    return await this.api.post('/user/plan/fund', data)
  }

  async updatePlan(data: Plan) {
    return await this.api.put(`/user/plan/${data.id}/update`, data)
  }
  async deletePlan(data: { id: any }) {
    return await this.api.delete(`/user/plan/${data.id}/delete`)
  }
}

const planService = new PlanService()

export default planService
